/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useRef, useContext, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import { ProductsContext } from '../../context'
// import {defaultCreateAppData, ICreateAppData} from '../'
// import {StepperComponent} from '../../../assets/ts/components'
// import {KTSVG} from '../../../helpers'
// import {Step1} from './steps/Step1'
// import {Step2} from './steps/Step2'
// import {Step3} from './steps/Step3'
// import {Step4} from './steps/Step4'
// import {Step5} from './steps/Step5'

const modalsRoot = document.getElementById('root-modals') || document.body

const ResellerDetailModal = ({show, handleClose, reseller, setReseller, onSubmit, onDelete}) => {
  const { resorts } = useContext(ProductsContext)

  const [filteredResorts, setFilteredResorts] = useState([])
  const [resortSearch, setResortSearch] = useState('')

  useEffect(() => {
    let fr = resorts.filter(resort => !reseller?.resorts?.includes(resort.id))
    if(resortSearch.length > 0) {
      fr = fr.filter(resort => resort.name.fr.toLowerCase().includes(resortSearch.toLowerCase()))
      setFilteredResorts(fr)
    } else {
      setFilteredResorts([])
    }
  }, [resortSearch, reseller])

  const updateData = (fieldsToUpdate) => {
    const updatedData = {...reseller, ...fieldsToUpdate}
    setReseller(updatedData)
  }

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      // onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>{ reseller?.id ? 'Update Network' : 'Create Network' }</h2>
        {/* begin::Close */}
        {/* <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div> */}
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Content */}
        <div className='flex-row-fluid py-lg-5 px-lg-15'>
          {/* <div className='mb-5'>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span>Language</span>
            </label>
            <div className='nav-group nav-group-outline nav-group-slim'>
              <label>
                <input
                  type='radio'
                  className='btn-check'
                  name='type'
                  value='fr'
                  checked={selectedLanguage === 'fr'}
                  onChange={(e) => setSelectedLanguage('fr')}
                />
                <span className='btn btn-sm btn-color-muted btn-active btn-active-primary'>
                  FR
                </span>
              </label>

              <label>
                <input type='radio' className='btn-check' name='type' value='en' checked={selectedLanguage === 'en'} onChange={(e) => setSelectedLanguage('en')} />
                <span className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4'>
                  EN
                </span>
              </label>

              <label>
                <input type='radio' className='btn-check' name='type' value='es' checked={selectedLanguage === 'es'} onChange={(e) => setSelectedLanguage('es')} />
                <span className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4'>
                  ES
                </span>
              </label>

              <label>
                <input type='radio' className='btn-check' name='type' value='it' checked={selectedLanguage === 'it'} onChange={(e) => setSelectedLanguage('it')} />
                <span className='btn btn-sm btn-color-muted btn-active btn-active-primary px-4'>
                  IT
                </span>
              </label>
            </div>
          </div> */}
          {/*begin::Form */}
          <form noValidate id='kt_modal_create_app_form'>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Company name</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-company-name'
                placeholder=''
                value={reseller?.company_name || ''}
                onChange={(e) =>
                  updateData({
                    company_name: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Email address</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-email'
                placeholder=''
                value={reseller?.email || ''}
                onChange={(e) =>
                  updateData({
                    email: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Phone number</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-email'
                placeholder=''
                value={reseller?.phone || ''}
                onChange={(e) =>
                  updateData({
                    phone: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Address line 1</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-address-line1'
                placeholder=''
                value={reseller?.address_line1 || ''}
                onChange={(e) =>
                  updateData({
                    address_line1: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Address line 2</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-address-line2'
                placeholder=''
                value={reseller?.address_line2 || ''}
                onChange={(e) =>
                  updateData({
                    address_line2: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>City</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-city'
                placeholder=''
                value={reseller?.city || ''}
                onChange={(e) =>
                  updateData({
                    city: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Zip code</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-zipcode'
                placeholder=''
                value={reseller?.zipcode || ''}
                onChange={(e) =>
                  updateData({
                    zipcode: e.target.value,
                  })
                }
              />
            </div>

            {/* RESORTS MULTISELECT */}
            {/** Text input where user enters resort name. A scrollable dropdown appears with a list of matching resorts. User can click on resort which appears in a list below. Resorts can be removed from the list by clicking an X button. */}

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                {/* <span className='required'>Resorts</span> */}
                <span>Resorts</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-resorts'
                placeholder=''
                value={resortSearch}
                onChange={(e) => {
                  setResortSearch(e.target.value)
                }}
              />
              <div className='fv-row mb-10'>
                <div className='d-flex flex-wrap'>
                  { filteredResorts.map((resort, resortIndex) =>
                    <div key={`resort_${resort.id}`} className='btn btn-sm btn-light btn-active-primary m-1' onClick={() => {
                      console.log('select resort', resort)
                      updateData({
                        resorts: [...(reseller.resorts || []), resort.id]
                      })
                      setResortSearch('')
                    }}>
                      { resort.name.fr }
                    </div>
                  )}
                </div>

                <div className='d-flex flex-wrap'>
                  { reseller?.resorts?.map((resortId, resortIndex) => {
                    const resort = resorts.find(resort => resort.id === resortId)
                    return (
                      <div key={`resort_${resortId}`} className='btn btn-sm btn-light m-1' >
                        { resort?.name?.fr || `[DELETED RESORT] ${resortId}` }                    
                        <span className='btn btn-sm btn-icon btn-active-color-primary ms-2' onClick={() => {
                        updateData({
                          resorts: reseller.resorts.filter(id => id !== resortId)
                        })
                      }}>
                          <i className='fas fa-times'></i>
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>


            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Status</label>
              <div className='col-lg-8 fv-row'>
                <select
                  className='form-select form-select-solid form-select-lg'
                  value={reseller?.status || ''}
                  onChange={e => updateData({
                    status: e.target.value
                  })}
                >
                  <option value=''>- NONE -</option>
                  <option value={'registered-intermediary'}>
                  {/* { 'Duly registered insurance intermediary' } */}
                  {'MIA Immatriculé'}
                  </option>                  
                  <option value={'pending-registration'}>
                  {/* { 'Insurance intermediary (registration pending)' } */}
                  {"MIA en cours d'immatriculation"}
                  </option>                  
                  <option value={'official-partner'}>
                  {/* { 'Official partner' } */}
                  { "Partenaire officiel" }
                  </option> 
                </select>
              </div>
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span>ORIAS Number</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-orias'
                placeholder=''
                value={reseller?.orias || ''}
                onChange={(e) =>
                  updateData({
                    orias: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2 d-row gap-4'>
                <span>Sociétaire Orion-TN</span>
                <input className='form-check-input' type='checkbox' checked={reseller?.orion} onChange={e => updateData({
                  orion: e.target.checked,
                })} />
              </label>
            </div>
            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2 d-row gap-4'>
                <span>Orion TN official distributor</span>
                <input className='form-check-input' type='checkbox' checked={reseller?.orion_tn_official_distributor ?? false} onChange={e => updateData({
                  orion_tn_official_distributor: e.target.checked,
                })} />
              </label>
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2 d-row gap-4'>
                <span>Orion TN official lead generator</span>
                <input className='form-check-input' type='checkbox' checked={reseller?.orion_tn_official_lead_generator ?? false} onChange={e => updateData({
                  orion_tn_official_lead_generator: e.target.checked,
                })} />
              </label>
            </div>

            {/* <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Sociétaire Orion-TN</span>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-name'
                placeholder=''
                value={reseller?.orion || ''}
                onChange={(e) =>
                  updateData({
                    orion: e.target.value,
                  })
                }
              />
            </div> */}

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>SIREN</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-siren'
                placeholder=''
                value={reseller?.siren || ''}
                onChange={(e) =>
                  updateData({
                    siren: e.target.value,
                  })
                }
              />
            </div>

            <div className='fv-row mb-10'>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>SIRET</span>
                {/* <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify your unique reseller title'
                ></i> */}
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='reseller-siret'
                placeholder=''
                value={reseller?.siret || ''}
                onChange={(e) =>
                  updateData({
                    siret: e.target.value,
                  })
                }
              />
            </div>

            {/*begin::Actions */}
            <div className='d-flex flex-row-fluid justify-content-between align-items-center gap-2 gap-lg-3'>
              <div className='me-2'>
                { reseller?.id &&
                  <button
                    type='button'
                    className='btn btn-lg btn-danger'
                    data-kt-stepper-action='next'
                    onClick={onDelete}
                  >
                    { 'Delete' }
                  </button>
                }
              </div>                
              <div className='d-flex gap-3'>
                <button
                  type='button'
                  className='btn btn-lg'
                  data-kt-stepper-action='next'
                  onClick={handleClose}
                >
                  { 'Close' }
                </button>
                <button
                  type='button'
                  className='btn btn-lg btn-primary'
                  data-kt-stepper-action='next'
                  onClick={onSubmit}
                >
                  { reseller?.id ? 'Update' : 'Create' }
                </button>
              </div>
            </div>
            {/*end::Actions */}
          </form>
          {/*end::Form */}
        </div>
        {/*end::Content */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default ResellerDetailModal
